import { redirect } from "react-router-dom";
import { Role, User } from "../../auth/types/interfaces";
import { forbiddenResponse, serviceUnavailableResponse } from "../constants";
import { ROUTES } from "../../app/constants";
import { JSON_FORMS_ROUTES } from "../../jsonForms/constants";
import { requireFeatureFlag, FeatureFlagsUnavailableError } from "src/app/featureFlags";

/**
 * AtoZ intake exists only in the `/json-forms` tree. With `enableJsonForms` off,
 * `JsonFormsLoader` redirects back to `/`, so redirecting there unconditionally
 * would loop.
 */
const isAtozIntakeAvailable = async (): Promise<boolean> => {
  try {
    return await requireFeatureFlag("enableJsonForms");
  } catch (error) {
    if (error instanceof FeatureFlagsUnavailableError) {
      throw serviceUnavailableResponse(
        "We could not confirm whether AtoZ claim intake is available right now. " +
          "Please retry in a few moments."
      );
    }
    throw error;
  }
};

export const loader = async (user: User) => {
  {
    if (user.roles.includes(Role.WC_CLAIM_PRODUCT_GROUP)) {
      return redirect(ROUTES.LANDING_PAGE);
    }
    if (user.roles.includes(Role.CARGO_CLAIM_USER)) {
      return redirect(ROUTES.CARGO_CLAIM_INTAKE_FORM);
    }
    // AtoZ comes before IPL: a user holding both is asked on the AtoZ pre-screen
    // whether the claim is excluded from AtoZ, and is sent on to IPL from there.
    if (user.roles.includes(Role.ATOZ_CLAIM_USER) && (await isAtozIntakeAvailable())) {
      return redirect(JSON_FORMS_ROUTES.ATOZ_CLAIM_INTAKE_FORM);
    }
    if (user.roles.includes(Role.IPL_CLAIM_USER)) {
      return redirect(ROUTES.IPL_CLAIM_INTAKE_FORM);
    }
    if (
      user.roles.includes(Role.WC_CLAIM_USER) ||
      user.roles.includes(Role.WC_CLAIM_USER_LIMITED) ||
      user.roles.includes(Role.WC_CLAIM_CANADA_USER)
    ) {
      return redirect(ROUTES.WC_CLAIM_INTAKE_FORM);
    }
    // If user has no roles then deny access to the app
    return forbiddenResponse();
  }
};
